import React from "react";
import { useTranslation } from "react-i18next";

export default function AccessibilityStatement() {
    const { t } = useTranslation();

    return (
        <div
            className="bg-cream min-h-screen text-darktext text-right space-y-6 sm:space-y-10 md:space-y-12 overflow-x-clip px-4 sm:px-6 md:px-8 py-10 max-w-3xl mx-auto"
            dir="rtl"
        >
            <h1 className="text-2xl font-bold mb-4">{t("accessibility.title")}</h1>

            <p>{t("accessibility.p1")}</p>
            <p>{t("accessibility.p2")}</p>

            <p>{t("accessibility.listIntro")}</p>
            <ul className="list-disc pr-6 space-y-2">
                <li>{t("accessibility.list.kb")}</li>
                <li>{t("accessibility.list.headings")}</li>
                <li>{t("accessibility.list.alt")}</li>
                <li>{t("accessibility.list.contrast")}</li>
                <li>{t("accessibility.list.skip")}</li>
            </ul>

            <p>{t("accessibility.p3")}</p>

            <p className="font-medium leading-relaxed">
                <a
                    href="https://www.wtb.org.il/contact/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cursor-pointer underline text-lime-700 hover:text-lime-800"
                >
                    {t("accessibility.contactLink")}
                </a>
            </p>

            <p>{t("accessibility.lastUpdated")}</p>
        </div>
    );
}